import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface CarbonSourceMasterState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allCarbonSourceMaster: [] | null | any;
}

const initialState: CarbonSourceMasterState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allCarbonSourceMaster: null,
};

export const carbonSourceMasterSlice = createSlice({
    name: 'CarbonSourceMaster',
    initialState,
    reducers: {
        setCarbonSourceMaster: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setCarbonSourceMasterBySearch: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setAllCarbonSourceMaster: (state, action) => {
            state.allCarbonSourceMaster = action.payload.data;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setCarbonSourceMaster, setCarbonSourceMasterBySearch, setAllCarbonSourceMaster, reset } = carbonSourceMasterSlice.actions;
export const getAllCarbonSourceMasterDetails = (state: RootState) => state.carbonSourceMaster.data;
export const getCarbonSourceMasterTotalRecords = (state: RootState) => state.carbonSourceMaster.totalRecords;
export const getAllCarbonSourceMasterBySearch = (state: RootState) => state.carbonSourceMaster.data;
export default carbonSourceMasterSlice.reducer;
